import { createAction, props } from '@ngrx/store';
import { ScreenEnum } from '@shared/enums/common-data/screen.enum';

export abstract class ScreenActions {
  static setCurrentScreen = createAction(
    '[setCurrentScreen] Set the current screen',
    props<{ currentScreen: ScreenEnum }>()
  );
}
